// JavaScript Document

function initFileInput(id) {

    const inputFileMultipleContainer = document.getElementById(id);
    const inputFileMultiple = inputFileMultipleContainer.querySelector('#inputFileMultiple'); 
    const fileList =       inputFileMultipleContainer.querySelector('#'+id+' .filelist');

    inputFileMultiple.addEventListener('change', (event) => {

        const files = event.target.files;
        fileList.innerHTML = '';
        let htmlOutput = '<div class="p-2 border"><strong>Dateien:</strong><ul class="list-unstyled">';
        let totalMB = 0;

        for (let i = 0; i < files.length; i++) {

            let file = files.item(i);
            htmlOutput += '<li>'+file.name;
            const fileSize = file.size/1000000;
            htmlOutput += ' (<span class="text-primary">'+fileSize.toFixed(2)+' MB</span>) </li>';

            totalMB = totalMB + fileSize;

        }
        
        //inputFileMultiple.setAttribute("isvalid", "true")
        if (totalMB > 5) {

            inputFileMultiple.setCustomValidity("Dokumente überschreiten 5MB");

            htmlOutput += '</ul><span class="text-danger"><strong>Total = '+totalMB.toFixed(2)+' MB</strong></span></div>';

        } else {


            inputFileMultiple.setCustomValidity("");
            htmlOutput += '</ul><span class="text-success"><strong>Total = '+totalMB.toFixed(2)+' MB</strong></span></div>';

        }

        appendHtml(fileList, htmlOutput);


    });
}
